export default __webpack_public_path__ + "static/media/animoca_brands.3aa5e428.svg";